import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link, useLocation } from "react-router-dom";
import { Chip, User, Button } from "@nextui-org/react";
import ImageSlider from "../../components/ImageSlider";
import { useSelector } from "react-redux";

import { toast } from "react-toastify";
import axios from "axios";
import logo from "../../assets/images/Capricorn_logo.png";
import { ChatBox, Quotes } from "../../routes";
import ClarificationBoard from "./ClarificationBoard";

import { useDispatch } from "react-redux";
import { refreshIfNeeded } from "../../store/actions/refreshIfNeeded";

const RequestDetails = () => {
  const quote_id = localStorage.getItem("quote_id");
  const { user } = useSelector((state) => state.auth);
  const [request, setRequest] = useState([]);
  const [images, setImages] = useState([]);
  const [create, setCreate] = useState(false);
  const [suppliers, setSuppliers] = useState([]);
  const [quoteIds, setQuotesIds] = useState([]);
  const navigate = useNavigate();

  const dispatch = useDispatch();

  // ---- Auth helpers (fresh token on demand) ----
  const authHeaders = () => ({
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  });

  const ensureAuth = async () => {
    await dispatch(refreshIfNeeded());
    return authHeaders();
  };

  const location = useLocation();

  const containsGenerateQuote = location.pathname.includes("generateQuote");
  const { id } = useParams();
  const safeLower = (str) => (typeof str === "string" ? str.toLowerCase() : "");

  const handleCreateQuote = () => {
    let data = {
      id,
      username: request?.request?.User,
      quantity: request?.request?.quantity,
    };
    localStorage.setItem("customer_request", JSON.stringify(data));
    navigate(`/request/generateQuote/${id}`);
  };

  const formatDate = (val) => {
    let date = new Date(val);
    const day = String(date?.getDate()).padStart(2, "0");
    const month = String(date?.getMonth() + 1).padStart(2, "0");
    const year = date?.getFullYear();

    return date ? `${day}/${month}/${year}` : "Invalid Date";
  };

  const handleClick = () => {
    localStorage.removeItem("quote_id");
  };

  useEffect(() => {
    (async () => {
      try {
        let token = localStorage.getItem("accessToken");
        const headers = await ensureAuth();
        let res;
        try {
          res = await axios.get(
            `${process.env.REACT_APP_SERVER_URL}/requests/get/${id}`,
            headers
          );
        } catch (err) {
          // if 401: refresh once again & retry
          if (err?.response?.status === 401) {
            const headers2 = await ensureAuth();
            res = await axios.get(
              `${process.env.REACT_APP_SERVER_URL}/requests/get/${id}`,
              headers2
            );
          } else {
            throw err;
          }
        }

        let data = res.data?.details;
        let suppliers = data?.supplierIds;
        setRequest(res.data?.details);
        setImages(data.images);
        // setQuotesIds(data?.quoteIds)
        setQuotesIds(data?.quoteIds?.[data?.quoteIds?.length - 1]);

        setSuppliers(data.supplierIds);
        if (suppliers.length > 0) {
          let val = suppliers.find((item) => {
            if (user.id === item) {
              return true;
            }
            return false;
          });
          if (val !== undefined) {
            setCreate(true);
          }
        }
      } catch (error) {
        let err = error.response?.data?.message;
        toast.error(err);
      }
    })();
  }, [user?.id, id]);

  return (
    <>
      <div className="grid md:grid-cols-2 gap-1 box-border w-full   ">
        {images?.length > 0 ? (
          <div className="w-full max-w-md md:max-w-none mx-auto">
            <ImageSlider images={images} />
          </div>
        ) : (
          <div className="flex justify-center pt-9 font-semibold">
            No Image Found
          </div>
        )}
        <div className="pt-2">
          <div className="flex flex-col sm:flex-row sm:justify-between gap-2">
            <h2 className="font-bold text-base sm:text-lg">
              Details About Request
            </h2>
            <Chip
              color={
                request?.request?.RequestStatus?.status === "New"
                  ? "primary"
                  : "warning"
              }
              variant="dot"
              // className={` ${
              //   request?.request?.RequestStatus?.status === "New"
              //     ? "text-blue-600 border-blue-500 bg-[#C1CAF2]"
              //     : "text-orange-400 border-[#F5A524] bg-[#FDEDD3]"
              // }`}
              className={`${request?.request?.RequestStatus?.status === "New"
                ? "text-blue-600 border-blue-500 bg-[#C1CAF2]"
                : "text-orange-400 border-[#F5A524] bg-[#FDEDD3]"
                } text-xs sm:text-sm`}
            >
              {request?.request?.RequestStatus?.status}
            </Chip>
          </div>
          <div className="flex items-center">
            {request?.request?.User?.capricorn_number && (
              <>
                (Capricorn Member)
                {/* <img src={logo} alt="logo" className="ml-2 h-5 inline" /> */}
                <img src={logo} alt="logo" className="ml-2 h-4 sm:h-5 inline" />{" "}
              </>
            )}
          </div>

          <div className="grid gap-y-2 ">
            <div className="grid grid-cols-2 sm:grid-cols-5 mt-8 gap-2 ">
              <div className="capitalize">
                <p className="font-semibold">Industry</p>
                <p className="capitalize text-[11px] sm:text-[15px]">
                  {request?.request?.User?.Industry}
                </p>
              </div>

              <div className="capitalize">
                <p className="font-semibold ">City</p>
                <p className="text-[13px] md:text-[15px]">
                  {request?.request?.User?.suburb}
                </p>
              </div>
              <div className="capitalize">
                <p className="font-semibold">State</p>
                <p className="capitalize text-[11px] sm:text-[15px]">
                  {request?.request?.User?.state}
                </p>
              </div>
              <div className="capitalize">
                <p className="font-semibold">Postcode</p>
                <p className="text-[13px] md:text-[15px]">
                  {request?.request?.User?.postcode}
                </p>
              </div>
              <div>
                <p className="text-[14px] md:text-sm font-semibold">
                  Created On
                </p>
                <p className="text-[13px] md:text-[15px]">
                  {formatDate(request?.request?.date_requested)}
                </p>
              </div>
            </div>

            <div className="">
              <div className="grid grid-cols-2 sm:grid-cols-5 gap-2 [&>div>p:last-child]:text-[0.75rem] sm:[&>div>p:last-child]:text-[0.875rem]  ">
                <div>
                  <div>
                    <p className="font-semibold capitalize">Make</p>
                    <p className="capitalize text-[11px] sm:text-[15px]">
                      {safeLower(
                        request?.request?.VehicleMake?.name ??
                        request?.request?.custom_model
                      )}
                    </p>
                  </div>
                  <div></div>
                </div>
                <div>
                  <p className="font-semibold ">Model Name</p>
                  <p className="capitalize text-[11px] sm:text-[15px]">
                    {safeLower(
                      request?.request?.VehicleModel?.name ??
                      request?.request?.custom_model
                    )}
                  </p>
                </div>
                <div>
                  <p className="font-semibold">Year</p>
                  <p className="text-[12px] md:text-[15px]">
                    {request?.request?.year}
                  </p>
                </div>
                {/* <div className="capitalize">
                  <p className="font-semibold capitalize">Rego</p>
                  <p>{request?.request?.rego}</p>
                </div> */}
                <div className="capitalize">
                  <p className="font-semibold ">Fuel Type</p>
                  <p className="text-[12px] md:text-[15px]">
                    {request?.request?.fuelType?.name || "Not Provided"}
                  </p>
                </div>

                <div>
                  <p className="font-semibold">Transmission</p>
                  <p className="text-[12px] md:text-[15px]">
                    {request?.request?.transmissionModel?.name ||
                      "Not Provided"}
                  </p>
                </div>
              </div>
              <div className="grid grid-cols-5 gap-2 [&>div>p:last-child]:text-[0.75rem] sm:[&>div>p:last-child]:text-[0.875rem]">
                <div className="capitalize col-span-1">
                  <p className="font-semibold">Body Style</p>
                  <p className="text-[12px] md:text-[15px]">
                    {request?.request?.bodyStyle?.name || "Not Provided"}
                  </p>
                </div>

                <div className="capitalize col-span-4 ">
                  {request?.request?.rego ? (
                    <>
                      <p className="font-semibold">Rego</p>
                      <p className="text-[12px] md:text-[15px]">
                        {request.request.rego}
                      </p>
                    </>
                  ) : request?.request?.vin ? (
                    <>
                      <p className="font-semibold">VIN</p>
                      <p className="text-[12px] md:text-[15px]">
                        {request.request.vin}
                      </p>
                    </>
                  ) : (
                    <>
                      <p className="font-semibold">Prof_Descreption</p>

                      <div className="w-full break-words whitespace-pre-line max-h-32 sm:max-h-40 overflow-y-auto pr-1 text-[11px] sm:text-[15px]">
                        {request?.request?.prof_descreption || "Not Provided"}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="flex gap-[80px]"></div>

            <div className=" ">
              <div className="capitalize">
                <p className="font-semibold">Part Name</p>
                <p className="capitalize text-[11px] sm:text-[15px]">
                  {safeLower(
                    request?.request?.Part?.name ??
                    request?.request?.custom_part_type
                  )}
                </p>
              </div>

              <div>
                <div className="capitalize">
                  <p className="font-semibold">Description:</p>
                  <p className="text-[0.75rem] sm:text-[0.875rem]">
                    {request?.request?.notes || "Not Provided"}
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-6 border-t pt-4 border-gray-200">
              <h2 className="font-bold text-base sm:text-lg mb-2">
                Customer Details
              </h2>
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
                <div className="capitalize col-span-1">
                  <p className="font-semibold">Contact Name</p>
                  <p className="text-[13px] md:text-[15px]">
                    {request?.request?.User?.first_name} {request?.request?.User?.last_name}
                  </p>
                </div>
                <div className="col-span-1">
                  <p className="font-semibold">Phone Number</p>
                  <p className="text-[13px] md:text-[15px]">
                    {request?.request?.User?.phone || "Not Provided"}
                  </p>
                </div>
                <div className="col-span-1 md:col-span-1 lg:col-span-1">
                  <p className="font-semibold">Email Address</p>
                  <p className="text-[13px] md:text-[15px] break-all">
                    {request?.request?.User?.email}
                  </p>
                </div>
                {request?.request?.User?.abn_number && (
                  <div className="col-span-1">
                    <p className="font-semibold">ABN Number</p>
                    <p className="text-[13px] md:text-[15px]">
                      {request?.request?.User?.abn_number}
                    </p>
                  </div>
                )}
                <div className="col-span-2 md:col-span-2 lg:col-span-3">
                  <p className="font-semibold">Business/Company Name</p>
                  <p className="text-[13px] md:text-[15px]">
                    {request?.request?.User?.business_name || request?.request?.User?.company_name || "Not Provided"}
                  </p>
                </div>
                <div className="col-span-2 md:col-span-3 lg:col-span-5 mt-1">
                  <p className="font-semibold">Full Address</p>
                  <p className="text-[13px] md:text-[15px]">
                    {[
                      request?.request?.User?.address_line_1,
                      request?.request?.User?.address_line_2,
                      request?.request?.User?.suburb,
                      [request?.request?.User?.state, request?.request?.User?.postcode].filter(Boolean).join(" ")
                    ].filter(Boolean).join(", ") || "Not Provided"}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {create && !containsGenerateQuote ? (
            <div className="">
              <Link to={`/quotes/${quoteIds}`}>
                <Button className="bg-lightBlue  text-white py-2 px-5 font-bold text-sm sm:text-base mt-5 mobile-only:w-full">
                  Quote Completed
                </Button>
              </Link>
              {/* <h1>Quotes:{quoteIds}</h1> */}
              <br />
              {quote_id && (
                <Link to={`/quotes/${quote_id}`}>
                  <Button
                    className="bg-purpleBtn text-white py-2 px-5 font-bold text-sm sm:text-base mt-5"
                    onClick={handleClick}
                  >
                    Go to quote
                  </Button>
                </Link>
              )}
            </div>
          ) : (
            !containsGenerateQuote && (
              <Button
                className="bg-lightBlue text-white py-2 px-5 font-bold mt-5"
                onClick={handleCreateQuote}
                disabled={request?.quotes?.id}
              >
                {request?.quotes?.id ? "Quote Already Created" : "Create Quote"}
              </Button>
            )
          )}
        </div>
      </div>
      {!containsGenerateQuote && (
        <div className="md:px-32">
          <ClarificationBoard requestId={id} />
        </div>
      )}
    </>
  );
};

export default RequestDetails;
